import styled from "styled-components";

export const VenueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
